import { useQuery } from 'react-query';
import { api } from '../lib/api';
import { QUERY_KEYS, QUERY_CONFIG } from '../constants/queryKeys';

interface NavbarProfileData {
  firstName?: string;
  profileImage?: string;
}

export const useNavbarProfile = () => {
  const fetchProfileData = async (): Promise<NavbarProfileData> => {
    const response = await api.get('/users/profile');
    const { firstName, profileImage } = response.data;
    return { firstName, profileImage };
  };

  const {
    data: profile,
    isLoading,
    error,
    refetch,
  } = useQuery(
    [QUERY_KEYS.NAVBAR_PROFILE],
    fetchProfileData,
    QUERY_CONFIG.DEFAULT,
  );

  return {
    profile,
    isLoading,
    error,
    refetch,
  };
};
